import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";
import {
  addPeopleToWarehouse,
  getWarehouseById,
} from "../../../services/Warehouse";
import WarehouseCard from "../../../components/WarehouseCard";
import { getSalesPersonById } from "../../../services/SalesPerson";
import SalesmanSelectingPopup from "../../../components/SalesmanSelectingPopup";
import SalesmanDataComponent from "../../../components/SalesmanDataComponent";
import { useHistory } from "react-router";

const useStyles = makeStyles({
  container: {
    padding: "20px",
  },
  categoryContainer: {
    padding: "10px",
  },
});

function WarehouseUpdate() {
  const history = useHistory();
  const classes = useStyles();
  const { warehouseId } = useParams();

  const [warehouse, setWarehouse] = useState(null);
  const [error, setError] = useState({});
  const [openSalesmanTable, setOpenSalesmanTable] = useState(false);
  const [selectedSalesman, setSelectedSalesman] = useState([]);
  const [selectedSalesmanData, setSelectedSalesmanData] = useState([]);

  useEffect(async () => {
    fetchWarehouseData();
  }, []);

  const salemanTableColumns = [
    { id: "name", label: "Name", minWidth: 80 },
    { id: "email", label: "email", minWidth: 100 },
    { id: "phone", label: "Status", minWidth: 100 },
    { id: "action", label: "Actions", minWidth: 100 },
  ];

  const fetchWarehouseData = async () => {
    let result = await getWarehouseById(warehouseId);
    console.log(result);
    if (result !== "Something went wrong...") {
      setWarehouse(result);
      setSelectedSalesmanData(result.salespersons);
      let salesmanIdList = result.salespersons.map(
        (salesman) => salesman.userId
      );
      setSelectedSalesman(salesmanIdList);
    } else {
      setError({
        ...error,
        warehouseDataFetchError: "Unable to fetch warehouse data!..",
      });
    }
  };

  const handleOpenSalesmanTable = () => {
    setOpenSalesmanTable(true);
  };

  const handleCloseSalesmanTable = async () => {
    if (selectedSalesman.length !== 0) {
      console.log(selectedSalesman[0]);
      let salesmanList = [];
      for (let i = 0; i < selectedSalesman.length; i++) {
        const salesmanResponse = await getSalesPersonById(selectedSalesman[i]);
        if (salesmanResponse === "Something went wrong...") {
          setError({
            ...error,
            _salesman: "Something went wrong...",
          });
          setOpenSalesmanTable(false);
          return;
        } else {
          salesmanList.push(salesmanResponse);
        }
      }
      console.log("Salesman Data: " + salesmanList);
      setSelectedSalesmanData(salesmanList);
      setOpenSalesmanTable(false);
    } else {
      setOpenSalesmanTable(false);
    }
  };

  const updateWarehouse = async () => {
    const finalValue = {
      warehouseId: warehouseId,
      salesPerson: selectedSalesman,
    };

    console.log("Final Data: ", finalValue);
    let result = await addPeopleToWarehouse(finalValue);

    if (result) {
      history.goBack();
    } else {
      setError({
        ...error,
        _warehouseUpdateError: "Unable to update warehose.. try again later..",
      });
    }
  };

  return (
    <Paper className={classes.container} elevation={8}>
      <Grid container spacing={2}>
        {error.warehouseDataFetchError ? (
          <Grid item>
            <Typography
              align="left"
              variant="caption"
              style={{
                color: "red",
                fontSize: 16,
                fontWeight: "bold",
                paddingLeft: 40,
              }}
            >
              {error.warehouseDataFetchError}
            </Typography>
          </Grid>
        ) : (
          <>
            <Grid item xs={12} sm={10} sx={12}>
              {warehouse ? <WarehouseCard warehouse={warehouse} /> : null}
            </Grid>
            <Grid item xs={12} sm={4} sx={12}>
              <Button onClick={handleOpenSalesmanTable} variant="outlined">
                Select Salesman
              </Button>
            </Grid>
            <Grid item xs={12} sm={10} sx={12}>
              <Paper elevation={3} style={{ padding: 10 }}>
                <Typography style={{ marginBottom: 10 }}>
                  Sales People
                </Typography>
                <Grid container spacing={1}>
                  {selectedSalesmanData.length === 0 ? (
                    <Grid item xs={12} sm={4} sx={12}>
                      <Typography
                        variant="caption"
                        gutterBottom
                        sx={{ display: "block" }}
                      >
                        Sales person not assigned for this warehouse
                      </Typography>
                    </Grid>
                  ) : null}

                  {selectedSalesmanData?.map((salesman) => {
                    console.log("Salesman data: ", salesman);
                    return (
                      <Grid item xs={12} sm={3} sx={12} style={{ margin: 10 }}>
                        <Grid style={{ width: 250 }}>
                          <SalesmanDataComponent salesman={salesman} />
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Paper>
            </Grid>
            {error._warehouseUpdateError ? (
              <Grid item>
                <Typography
                  align="left"
                  variant="caption"
                  style={{
                    color: "red",
                    fontSize: 16,
                    fontWeight: "bold",
                    paddingLeft: 40,
                  }}
                >
                  {error._warehouseUpdateError}
                </Typography>
              </Grid>
            ) : null}
            <Grid item xs={12} sm={10} sx={12}>
              <Button variant="contained" onClick={updateWarehouse}>
                Save
              </Button>
            </Grid>
          </>
        )}
        {openSalesmanTable ? (
          <SalesmanSelectingPopup
            setOpenSalesmanTable={setOpenSalesmanTable}
            openSalesmanTable={openSalesmanTable}
            handleCloseSalesmanTable={handleCloseSalesmanTable}
            setSelectedSalesman={setSelectedSalesman}
            selectedSalesman={selectedSalesman}
            isOneChoise={false}
          />
        ) : null}
      </Grid>
    </Paper>
  );
}

export default WarehouseUpdate;
